export const getBasename = (): string => {
  // No basename needed for custom domain
  if (window.location.hostname === 'birgermoell.com') {
    return '';
  }
  // Use /birger basename only for GitHub Pages domain
  if (window.location.hostname === 'birgermoell.github.io') {
    return '/birger';
  }
  // Default to empty for local development
  return '';
}; 